import { useEffect, useState } from "react";
import { DeleteRedIcon, EditIcon, FilterIcon, PlusThickWhiteIcon, PlusThinWhiteIcon } from "../../../assets/icons";
import AddTableView from "./AddTableView";
import { TableSettingsItemDTO } from "../../../models/table/table.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import { useParams } from "react-router-dom";
import { tableService } from "../../../services/tableService";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { TableShapeType } from "../../../models/base/TableShapeType";
import { Switch } from "@mui/material";
import { TableShape } from "../../../utils/mappingEnums";
import EditTableView from "./EditTableView";
import Loader from "../../shared/Loader";
import ConfirmModal from "../../shared/ConfirmModal";
import { confirmDialog } from "../../../utils/confirmDialog";



const TablesPage: React.FC = () => {

    const [isAddTableViewOpen, setIsAddTableViewOpen] = useState(false);
    const [isEditTableViewOpen, setIsEditTableViewOpen] = useState(false);
    const [editTableId, setEditTableId] = useState<string | null>(null);
    const [searchFilter, setSearchFilter] = useState("");

    const [tables, setTables] = useState<TableSettingsItemDTO[]>([]);

    const [loading, setLoading] = useState(false);

    const { notify } = useNotification();

    const { localId } = useParams<{ localId: string }>();


    useEffect(() => {
        fetchTables();
    }, []);


    const fetchTables = async () => {

        if (!localId) {
            notify("error", "Local Id nedostaje za učitavanje stolova.");
            return;
        }

        setLoading(true);
        try {
            const response = await tableService.getTablesByLocalId(localId);

            if (response && response.data) {
                setTables(response.data);
            } else {
                notify("error", "Nije moguće učitati stolove.");
            }
        } catch (error: any) {
            notify("error", "Došlo je do greške prilikom učitavanja stolova.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const deleteAsync = async (id: string) => {

        if (!localId) {
            notify("error", "Local Id nedostaje za brisanje stola.");
            return;
        }

        let comfirm = await confirmDialog({
            title: "Da li ste sigurni da želite da obrišete ovaj sto?",
            description: "Ova akcija je nepovratna.",
            isDelete: true
        })

        if (!comfirm)
            return;

        setLoading(true);
        try {
            const response = await tableService.deleteTable(localId, id);
            if (response.success) {
                notify("success", "Sto je uspešno obrisan.");
                fetchTables();
            } else {
                notify("error", "Došlo je do greške prilikom brisanja stola.");
            }
        } catch (error: any) {
            notify("error", "Došlo je do greške prilikom brisanja stola.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };



    if (loading) {
        <Loader />
    }


    return (
        <>
            {isAddTableViewOpen &&
                <AddTableView
                    onClose={() => {
                        setIsAddTableViewOpen(false)
                        fetchTables();
                    }}
                />
            }

            {isEditTableViewOpen && editTableId &&
                <EditTableView
                    id={editTableId}
                    onClose={() => {
                        setIsEditTableViewOpen(false);
                        fetchTables();
                    }}
                />
            }

            <section className="tables-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Upravljanje stolovima</h2>
                                <div className="text-block">
                                    Upravljajte stolovima, njihovim pozicijama i statusima<br />
                                </div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary" onClick={() => setIsAddTableViewOpen(true)}>
                                    <img loading="lazy" src={PlusThinWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Dodaj sto</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div table-block-div">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Prikaz stolova</div>
                                    <div className="list-header-description">
                                        Ukupno stolova: {tables.length} ({tables.filter(t => t.isActive).length} aktivnih)<br />
                                    </div>
                                </div>
                                <div className="list-header-filer">
                                    <img loading="lazy" src={FilterIcon} alt="" className="subcategory-header-filter-image" />
                                    <div className="list-header-filer-form w-form">
                                        <input className="form-input w-input" placeholder="Pretrazi stolove..." type="text"
                                            value={searchFilter}
                                            onChange={(e) => setSearchFilter(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="list-div">
                                <div className="list-row-div list-header-row tables">
                                    <div>Broj</div>
                                    <div>Kapacitet</div>
                                    <div>Napomena</div>
                                    <div>Oblik</div>
                                    <div>Moguće rezervisati</div>
                                    <div>Aktivan</div>
                                    <div id="w-node-a811a1fe-d9ac-aa90-1c4e-cb5b694f51be-1cee91cf">Akcije</div>
                                </div>

                                {tables
                                    .filter(t => t.number.toString().includes(searchFilter)
                                        || (t.description && t.description.toLowerCase().includes(searchFilter.toLowerCase())))
                                    .map((table) => (
                                        <div className="list-row-div tables">

                                            <div className="div-block-10">
                                                <div className="_1rem-bold">{table.number}</div>
                                            </div>

                                            <div className="div-block-10">
                                                <div>{table.capacity}</div>
                                            </div>

                                            <div className="div-block-10">
                                                <div className="sa-owner-company-name">{table.description || "/"}</div>
                                            </div>

                                            <div className="div-block-2 location">
                                                <div>{TableShape(table.shape)}</div>
                                            </div>

                                            {table.isReservable ? (
                                                <div className="small-box-div green-bg">Da</div>
                                            ) : (
                                                <div className="small-box-div grey-bg">Ne</div>
                                            )}

                                            {table.isActive ? (
                                                <div className="small-box-div green-bg">Da</div>
                                            ) : (
                                                <div className="small-box-div grey-bg">Ne</div>
                                            )}


                                            <div id="w-node-a811a1fe-d9ac-aa90-1c4e-cb5b694f51d5-1cee91cf" className="table-row-action-btns-div">
                                                <img loading="lazy" src={EditIcon} alt="" className="category-list-div-row-actions-image"
                                                    onClick={() => {
                                                        setEditTableId(table.id);
                                                        setIsEditTableViewOpen(true);
                                                    }} />
                                                <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image"
                                                    onClick={() => deleteAsync(table.id)}
                                                />
                                            </div>
                                        </div>
                                    ))}

                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default TablesPage;